
import { controls } from "../../controls";

const ms215 = {
  label: "Release Cheque Stop Payment",
  pageLabel: "Release Cheque Stop Payment",
  starting: true,
  url: "ms215",
  pageType: "history",
  form: [
    ...controls.displayText({ label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch" }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-2" }),

    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ isRequired: true, width: "col-sm-2" }),
    ...controls.showData({ width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),
    ...controls.displayText({ label: "", width: "col-sm-6" }),
    ...controls.displayText({ star: true, label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      isRequired: true, beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ data: "account_number_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.magicDateLabel({ star: true, label: "Date", width: "col-sm-2" }),
    ...controls.magicDate({ isRequired: true, dateType: "ontype", name: "cheque_date", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-8" }),
    ...controls.displayText({ star: true, label: "Cheque Number", width: "col-sm-2 " }),
    ...controls.chequeNumber({
      onLeave: ["checkChqStatus"],
      isRequired: true, width: "col-sm-2", parents: [{
        name: 'cheque_date',
        match: "exist",
        show: 'readonly'
      }]
    }),
    ...controls.showData({ isRequired: true, data: "cheque_status", displaytype: 'cheque_status', width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-6" }),
    // ...controls.displayText({ star: true, width: "col-sm-2",label:"Cheque Number" }),
    // ...controls.numberOnly({isRequired: true,placeHolder: "Cheque Number",name:"cheque_number"}),
    // ...controls.displayText({ width: "col-sm-8" }),
    ...controls.displayText({ style: { textAlign: 'right' }, tab: "filter", label: "ChequeAmount", width: "col-sm-2" }),
    ...controls.numtoword({
      tab: "filter", convertedTo: "cheque_amount_text", name: "cheque_amount", width: "col-sm-2",

    }),
    ...controls.showData({
      tab: "filter", data: "cheque_amount_text", name: "cheque_amount_text", width: "col-sm-8", style: { fontSize: 14 },
    }),

    ...controls.displayText({ star: true, label: "Reason", width: "col-sm-2" }),
    ...controls.Reason({
      isRequired: true, parents: [{
        name: 'cheque_status',
        match: "in",
        value: [2],
        show: 'readonly'
      }]
    }),
    ...controls.showData({ data: "reason_display", name: "reason_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ width: "col-sm-2", label: "Reason Description" }),
    ...controls.text({ placeHolder: "Reason Description", name: "reason_description" }),
    ...controls.displayText({ width: "col-sm-8" }),
    ...controls.displayText({ width: "col-sm-2", label: "Remarks" }),
    ...controls.text({ placeHolder: "Remarks", name: "remarks" }),
  ]
};

export default ms215;
